import { LifeBuoy, LogOut } from "lucide-react";

import { useLogout } from "@/features/auth/hooks";
import { useAuthStore } from "@/features/auth/store";

/**
 * Indicateur de session SUPPORT (staff GoldenTech dans l'espace d'une
 * clinique, claim `sup`) : bulle FLOTTANTE en bas à gauche — visible en
 * permanence sans occuper une rangée pleine largeur ni gêner le contenu.
 * Bas-DROIT réservé aux toasts (Sonner). Non masquable : c'est un marqueur
 * de sécurité ; « Quitter » ferme la session support.
 */
export function SupportBanner() {
  const me = useAuthStore((s) => s.me);
  const logout = useLogout();

  if (!me?.support_by) return null;

  const org = me.memberships.find(
    (m) => m.organisation_id === me.active_organisation_id,
  )?.organisation_name;

  return (
    <div
      role="status"
      title={`Accès support GoldenTech${org ? ` — ${org}` : ""} (ouvert par ${me.support_by})`}
      className="fixed bottom-4 left-4 z-50 flex max-w-[92vw] items-center gap-2 border border-white/20 bg-info px-3 py-2 text-xs font-medium text-white shadow-lg"
    >
      <LifeBuoy className="h-4 w-4 shrink-0" aria-hidden />
      <span className="min-w-0 truncate">Support{org ? ` — ${org}` : ""}</span>
      <button
        type="button"
        onClick={() => logout.mutate()}
        disabled={logout.isPending}
        className="ml-1 inline-flex shrink-0 items-center gap-1 bg-black/20 px-2 py-1 font-semibold transition-colors hover:bg-black/30 disabled:opacity-60"
      >
        <LogOut className="h-3.5 w-3.5" aria-hidden />
        Quitter
      </button>
    </div>
  );
}
